import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { TransactionListHeaderComponent } from "../transaction-list-header.component";
import { Component } from "@angular/core";
import { config } from "@config";
import { FiatTransaction } from "@models/transaction";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { ContactService } from "@main-services/contact.service";
import { PayAccountService } from "@main-services/pay_account.service";

@Component({
	selector: "transaction-list-tag",
	templateUrl: "./transaction-list-tag.component.html",
	styleUrls: ["./transaction-list-tag.component.scss"],
	standalone: false
})
export class TransactionListTagComponent extends TransactionListHeaderComponent {
	public constructor(
		protected modalService: ModalService,
		protected tradableWalletListService: TradableWalletListService,
		protected tradableListService: TradableListService,
		protected accountService: AccountService,
		protected fiatWalletService: FiatWalletService,
		protected fiatService: FiatService,
		protected contactService: ContactService,
		protected masterdataService: MasterdataService,
		protected payaccountService: PayAccountService,
		protected translationService: TranslationService
	) {
		super(
			modalService,
			tradableWalletListService,
			tradableListService,
			fiatWalletService,
			fiatService,
			contactService,
			masterdataService,
			payaccountService,
			translationService
		);
	}

	public getHDArticle(): string {
		let transaction: string = "crypto_withdraw";
		if (this.transaction instanceof FiatTransaction) {
			transaction = this.isFiatSend() ? "fiat_send" : "fiat_withdraw";
		}

		return this.translationService.getHdLink() + config.externalPaths[transaction]["hdLink"];
	}

	public isSEPAWithdrawProcessing(): boolean {
		if (this.payoutAccount) {
			return (
				this.transaction.getType() === "withdrawal" &&
				this.transaction.isStatus("processing") &&
				this.payoutAccount.getProviderId() === "1"
			);
		}
		return false;
	}
}
